var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { HashRouter, Switch, Route, withRouter } from "react-router-dom";
import { trackEntryHistory } from "@common/utils/entryHistory";
import LoginLayout from "./layout/loginLayout";
import AllowAnonymousLayoutLayout from "./layout/allowAnonymousLayoutLayout";
import MainLayout from "./layout/mainLayout";
import { CallApp, AppPromotion, AppointmentDetails, ErrorPage } from './scenes';
import NewMainLayout from "./layout/newMainLayout";
import { NotificationManager } from "oned";
var NoMatch = function () {
    // no match go home.
    return React.createElement("div", null, "not found");
};
var exteriorAllowAnonymousMenus = [
    { path: '/callApp', component: CallApp, title: 'CallApp' },
    { path: '/AppPromotion', component: AppPromotion, title: 'AppPromotion' },
    { path: '/appointmentDetails', component: AppointmentDetails, title: 'AppointmentDetails' },
    { path: '/error/:code', component: ErrorPage, title: 'Error' },
];
/**
 * Starts entry tracking in the constructor, so it is listening before any child Redirect fires
 * on mount (children mount before this one's componentDidMount would run).
 */
var EntryHistoryTracker = /** @class */ (function (_super) {
    __extends(EntryHistoryTracker, _super);
    function EntryHistoryTracker(props) {
        var _this = _super.call(this, props) || this;
        trackEntryHistory(props.history);
        return _this;
    }
    EntryHistoryTracker.prototype.render = function () {
        return null;
    };
    return EntryHistoryTracker;
}(Component));
var TrackEntryHistory = withRouter(EntryHistoryTracker);
var Router = function () {
    return (React.createElement(React.Suspense, { fallback: null },
        React.createElement(HashRouter, null,
            React.createElement(TrackEntryHistory, null),
            React.createElement(NotificationManager, null),
            React.createElement(Switch, null,
                exteriorAllowAnonymousMenus.map(function (x) {
                    return React.createElement(Route, { key: x.path, exact: true, path: x.path, component: x.component, title: x.title });
                }),
                React.createElement(Route, { path: "/emailToSchedule/(tokenExpired|unableSchedule)", render: function (props) { return React.createElement(AllowAnonymousLayoutLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/ResidentScheduleOptimization/EmailToSchedule/(tokenExpired|unableSchedule|noTechnician|timeApproaching)", render: function (props) { return React.createElement(AllowAnonymousLayoutLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/ResidentScheduleOptimization/(EmailToSchedule|EmailToSchedule/success)", render: function (props) { return React.createElement(MainLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/SuperintendentBooking/Booking", render: function (props) { return React.createElement(AllowAnonymousLayoutLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/account", render: function (props) { return React.createElement(LoginLayout, __assign({}, props)); } }),
                React.createElement(Route, { path: "/newRequest", render: function (props) { return React.createElement(NewMainLayout, __assign({}, props, { needCopilotFixedButton: true })); } }),
                React.createElement(Route, { path: "/", render: function (props) { return React.createElement(MainLayout, __assign({}, props, { needCopilotFixedButton: true })); } }),
                React.createElement(Route, { component: NoMatch })))));
};
export default Router;
